(function () {
  'use strict';

  function shuffled(items) {
    const result = items.slice();
    for (let i = result.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  }

  function modelKey(card) {
    return card.dataset.productModel || card.dataset.productHandle;
  }

  function readPrevious(key) {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(item => typeof item === 'string') : [];
    } catch (_) { return []; }
  }

  function rotateProducts(section, usedModels) {
    const grid = section.querySelector('[data-product-grid]');
    if (!grid) return;
    const pools = {};
    section.querySelectorAll('template[data-pool]').forEach(template => {
      pools[template.dataset.pool] = Array.from(template.content.querySelectorAll('[data-product-handle]'));
    });
    const key = 'eb-home-selection-v1:' + section.dataset.rotation;
    const previous = new Set(readPrevious(key));
    const selected = [];
    const localModels = new Set(usedModels);
    function take(cards, count) {
      const candidates = shuffled(cards || []);
      // Prefer products not shown on the previous load; a short pool still works.
      candidates.sort((a, b) => Number(previous.has(modelKey(a))) - Number(previous.has(modelKey(b))));
      let added = 0;
      for (const card of candidates) {
        const model = modelKey(card);
        if (!model || localModels.has(model)) continue;
        selected.push(card);
        localModels.add(model);
        added += 1;
        if (added === count) break;
      }
    }
    if (section.dataset.rotation === 'favorites') {
      take(pools.new, 2);
      take(pools.proven, 2);
      if (selected.length < 4) take([...(pools.new || []), ...(pools.proven || [])], 4 - selected.length);
    } else {
      take(pools.sale, 4);
    }
    if (!selected.length) return; // Keep the server-rendered fallback.
    const fragment = document.createDocumentFragment();
    selected.forEach(card => {
      fragment.appendChild(card.cloneNode(true));
      usedModels.add(modelKey(card));
    });
    grid.replaceChildren(fragment);
    try { sessionStorage.setItem(key, JSON.stringify(selected.map(modelKey))); } catch (_) { /* Storage is optional. */ }
    section.dataset.rotationReady = 'true';
  }

  function initCarousel(carousel) {
    const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
    const controls = carousel.querySelector('[data-carousel-controls]');
    if (slides.length < 2 || !controls) return;
    const previous = controls.querySelector('[data-prev]');
    const next = controls.querySelector('[data-next]');
    const pause = controls.querySelector('[data-pause]');
    const status = controls.querySelector('[data-slide-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let paused = reducedMotion.matches;
    let hovered = false;
    let focused = false;
    let visible = true;
    let timer = null;

    function updatePauseButton() {
      pause.setAttribute('aria-label', paused ? 'Reanudar presentación' : 'Pausar presentación');
      pause.querySelector('span').textContent = paused ? 'Reanudar' : 'Pausar';
      pause.querySelector('i').className = paused ? 'fa fa-play' : 'fa fa-pause';
      status.setAttribute('aria-live', paused ? 'polite' : 'off');
    }
    function schedule() {
      window.clearTimeout(timer);
      timer = null;
      if (paused || hovered || focused || !visible || document.hidden || !carousel.isConnected) return;
      timer = window.setTimeout(() => { show(index + 1); schedule(); }, 6500);
    }
    function show(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        slide.hidden = position !== index;
        slide.classList.toggle('is-entering', position === index);
      });
      status.textContent = (index + 1) + ' / ' + slides.length;
    }
    function manualStep(direction) {
      paused = true;
      updatePauseButton();
      show(index + direction);
      schedule();
    }
    previous.addEventListener('click', () => manualStep(-1));
    next.addEventListener('click', () => manualStep(1));
    pause.addEventListener('click', () => { paused = !paused; updatePauseButton(); schedule(); });
    carousel.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    carousel.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    carousel.addEventListener('focusin', () => { focused = true; schedule(); });
    carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); schedule(); });
    controls.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      manualStep(event.key === 'ArrowRight' ? 1 : -1);
    });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', event => {
      if (event.matches) paused = true;
      updatePauseButton(); schedule();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: 0.15});
      observer.observe(carousel);
    }
    controls.hidden = false;
    updatePauseButton();
    show(0);
    schedule();
  }

  function init(root) {
    root.querySelectorAll('.eb-home[data-home-refinement]').forEach(home => {
      if (home.dataset.initialized === 'true') return;
      home.dataset.initialized = 'true';
      const usedModels = new Set();
      home.querySelectorAll('[data-rotation]').forEach(section => rotateProducts(section, usedModels));
      const carousel = home.querySelector('[data-carousel]');
      if (carousel) initCarousel(carousel);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
